import { ActionIcon, Button, Group, Icon, Radio } from "@/components"
import { CoreModal } from "@/components/CoreModal"
import { getMessageFieldName } from "@/pages/campaign-form/components/campaigns/writeALetter/Message.helper"
import { useStyles } from "@/pages/campaign-form/components/sections/message/TargetedOfficialsSelectionBlocked/TargetedOfficialsSelectionBlocked.styles"
import { CampaignFormValues } from "@/pages/campaign-form/types"
import { Text } from "@mantine/core"
import { useDisclosure } from "@mantine/hooks"
import React from "react"
import { useFormContext } from "react-hook-form"

export const clearMessages = (formContext, prefix) => {
    const campaign_messages = formContext.getValues("message_groups")

    const messageGroupsName = `${prefix ? prefix + "." : ""}message_groups`

    campaign_messages.forEach((_, index) => {
        formContext.setValue(`${messageGroupsName}.${index}.legacy_base_searches`, null)
        formContext.setValue(`${messageGroupsName}.${index}.legacy_exclude_message_group`, null)
        formContext.setValue(`${messageGroupsName}.${index}.custom_officials_searches`, [])
    })
    formContext.setValue("message_groups", campaign_messages)
}

export interface TargetedOfficialsSelectionBlockedProps {
    messageIndex: number
    prefix?: string | null
}

export const TargetedOfficialsSelectionBlocked = ({
    messageIndex,
    prefix = null,
}: TargetedOfficialsSelectionBlockedProps) => {
    const { classes } = useStyles()
    const [opened, { close, open }] = useDisclosure(false)
    const formContext = useFormContext<CampaignFormValues>()

    const messageGroupsName = `${prefix ? prefix + "." : ""}message_groups`
    const name = formContext.getValues(messageGroupsName)[messageIndex]?.name

    return (
        <>
            <CoreModal
                title={"Reset Targeting?"}
                opened={opened}
                close={close}
                onConfirm={() => {
                    clearMessages(formContext, prefix)
                    close()
                }}
                onCancel={() => close()}
                confirmLabel={"Reset"}
                closeOnClickOutside={false}
            >
                <Text>
                    You must reset the targeting for this message group in order to edit it. Your current custom groups
                    will be removed and you will have to recreate your groups.
                </Text>
            </CoreModal>
            <Radio.Group
                name={getMessageFieldName(messageIndex, "uses_default_member_list", prefix)}
                label="Choose type of officials"
                transform={{
                    input: (input: boolean) => String(input),
                    output: (output: string) => (output === "true" ? true : false),
                }}
            >
                <Group>
                    <Radio value={"true"} label="Standard" onClick={() => open()} />
                    <Radio value={"false"} label="Custom officials" onClick={() => open()} />
                </Group>
            </Radio.Group>
            <div className={classes.container}>
                <Button
                    leftIcon={<Icon icon="plus" />}
                    variant="outline"
                    className={classes.button}
                    onClick={() => open()}
                >
                    {"Add officials"}
                </Button>
                <div className={classes.containerIcon}>
                    <div
                        role="button"
                        tabIndex={messageIndex}
                        className={classes.pill}
                        onClick={() => open()}
                        onKeyDown={() => open()}
                        aria-label="Custom button"
                    >
                        <Icon icon="lock" iconFamily="far" size="xs" className={classes.actionIcon} />
                        {name}
                        <ActionIcon className={classes.actionIcon} onClick={(e) => open()} variant="transparent">
                            <Icon icon="times" iconFamily="far" />
                        </ActionIcon>
                    </div>
                </div>
            </div>
        </>
    )
}
